import apiClient from './apiClient';

export const submitReport = async (payload) => {
  const response = await apiClient.post('/api/reports', payload);
  return response.data;
};

export const getAllReports = async (params = {}) => {
  const response = await apiClient.get('/api/reports', { params });
  return response.data;
};

export const getReportById = async (id) => {
  const response = await apiClient.get(`/api/reports/${id}`);
  return response.data;
};

export const updateReportStatus = async (id, payload) => {
  const response = await apiClient.patch(`/api/reports/${id}`, payload);
  return response.data;
};

export const getReportStats = async () => {
  const response = await apiClient.get('/api/reports/stats');
  return response.data;
};
